module.exports = __webpack_public_path__ + "img/wissenschaft-online.f61179fc.gif";